module.exports = __webpack_public_path__ + "img/qq-group1.d6e97a8b.jpg";